var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "微信审核详情",
        visible: _vm.visible,
        width: "880px",
        top: "5vh",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "audit-detail-body",
        },
        [
          _c("el-alert", {
            attrs: {
              title:
                "此处实时查询微信，仅供查看，不更新本地审核状态、驳回原因或完成时间。列表及发布操作仍依据本地记录。",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _vm.queryError
            ? _c("el-alert", {
                attrs: {
                  title: _vm.queryError,
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm.record && !_vm.record.wechatAuditId
            ? _c("el-alert", {
                attrs: {
                  title:
                    "当前记录没有微信审核单号，仅展示本地记录和提审参数，不请求微信。",
                  type: "info",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.statusMismatch
            ? _c("el-alert", {
                attrs: {
                  title:
                    "微信实时状态为「" +
                    _vm.statusLabel(_vm.wechatAuditStatus) +
                    "」，本地为「" +
                    _vm.statusLabel(_vm.record.auditStatus) +
                    "」。请检查审核结果回调，本次查询不会修正本地记录。",
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.record
            ? [
                _c("h4", [_vm._v("本地审核记录")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "detail-grid" },
                  _vm._l(_vm.localFields, function (field) {
                    return _c(
                      "div",
                      {
                        key: field.label,
                        staticClass: "detail-item",
                        class: { "detail-item-full": field.full },
                      },
                      [
                        _c("span", { staticClass: "detail-label" }, [
                          _vm._v(_vm._s(field.label)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "detail-value" }, [
                          _vm._v(_vm._s(_vm.displayText(field.value))),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.wechatResult
                  ? [
                      _c("h4", [_vm._v("微信实时审核信息")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "detail-grid" },
                        _vm._l(_vm.wechatFields, function (field) {
                          return _c(
                            "div",
                            {
                              key: field.label,
                              staticClass: "detail-item",
                              class: { "detail-item-full": field.full },
                            },
                            [
                              _c("span", { staticClass: "detail-label" }, [
                                _vm._v(_vm._s(field.label)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "detail-value" }, [
                                _vm._v(_vm._s(_vm.displayText(field.value))),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.screenshotUrls.length
                        ? _c(
                            "div",
                            { staticClass: "screenshot-list" },
                            _vm._l(_vm.screenshotUrls, function (url) {
                              return _c(
                                "a",
                                {
                                  key: url,
                                  attrs: {
                                    href: url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticClass: "audit-screenshot",
                                      attrs: { src: url, fit: "contain" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "error" },
                                          slot: "error",
                                        },
                                        [
                                          _vm._v(
                                            "截图无法直接展示，点击打开原图"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-tip" }, [
                        _vm._v(
                          "微信未返回的字段显示“-”；截图可能返回素材ID，此处保留原值，返回图片URL时支持预览。接口未提供实际审核完成时间，本地完成时间来自已保存的记录。"
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-collapse",
                  { staticClass: "detail-snapshots" },
                  [
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "本次提审参数快照（本地保存）",
                          name: "submit",
                        },
                      },
                      [
                        _c("pre", [
                          _vm._v(
                            _vm._s(_vm.formatJson(_vm.record.submitPayload))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-collapse-item",
                      {
                        attrs: {
                          title: "历史微信响应（本地保存，本次查询不覆盖）",
                          name: "history",
                        },
                      },
                      [
                        _c("pre", [
                          _vm._v(
                            _vm._s(_vm.formatJson(_vm.record.wechatResponse))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.wechatResult
                      ? _c(
                          "el-collapse-item",
                          {
                            attrs: {
                              title: "本次微信查询响应（WxJava 解析结果）",
                              name: "wechat",
                            },
                          },
                          [
                            _c("pre", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatJson(
                                    _vm.wechatResult.response ||
                                      _vm.wechatResult
                                  )
                                )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.loadDetail },
            },
            [_vm._v("刷新详情")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }